import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { Input, Button, Header } from 'semantic-ui-react';
import NoFormInputs from './NoFormInputs';
import Image from '../../../atoms/Image';
import { useRecaptcha } from '../../../components/RecaptchaProvider/RecaptchaProvider.hooks';
import { EmailCaptureButtonPropType, EmailCaptureFieldsPropType, EmailCaptureImagePropType, EmailCaptureTypePropType } from '../EmailCapture.propTypes';
import closebtnImg from '../assets/closebtn.png';
import closebtnDarkImg from '../assets/closebtnDark.png';
var defaultProps = {
  isSuccess: false,
  image: null,
  isSubmitting: false,
  formFieldValues: {},
  errors: {},
  darkCloseBtn: true,
  subheaderText: null
};
export default function FormInputs(props) {
  var isSubmitting = props.isSubmitting,
    isSuccess = props.isSuccess,
    updateFormFields = props.updateFormFields,
    submitForm = props.submitForm,
    closeEmailCapture = props.closeEmailCapture,
    type = props.type,
    headerText = props.headerText,
    subheaderText = props.subheaderText,
    description = props.description,
    descriptionTextColor = props.descriptionTextColor,
    button = props.button,
    fields = props.fields,
    textColor = props.textColor,
    bgColor = props.bgColor,
    image = props.image,
    errors = props.errors,
    darkCloseBtn = props.darkCloseBtn;
  var _useRecaptcha = useRecaptcha(),
    _useRecaptcha2 = _slicedToArray(_useRecaptcha, 2),
    recaptchaLoaded = _useRecaptcha2[1];
  var displayCloseBtn = type === 'modal' && (!image || image.placement === 'left');
  var setBgColorStyle = {};
  if (image && image.placement !== 'background' || !image) {
    setBgColorStyle = {
      backgroundColor: bgColor
    };
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "emailcapture-form",
    style: setBgColorStyle
  }, /*#__PURE__*/React.createElement("div", {
    id: "emailcapture-form-subheader-close-wrapper"
  }, subheaderText && /*#__PURE__*/React.createElement("p", {
    className: "emailcapture-form-subheader",
    style: {
      color: textColor
    }
  }, subheaderText), displayCloseBtn && /*#__PURE__*/React.createElement(Image, {
    as: "a",
    id: "closeEmailCapture",
    src: darkCloseBtn ? closebtnDarkImg : closebtnImg,
    onClick: closeEmailCapture
  })), /*#__PURE__*/React.createElement(Header, {
    className: "emailcapture-form-header",
    style: {
      color: textColor
    }
  }, headerText), /*#__PURE__*/React.createElement("p", {
    className: "emailcapture-form-description",
    style: {
      color: descriptionTextColor
    }
  }, description), isSuccess && /*#__PURE__*/React.createElement(NoFormInputs, null), !isSuccess && /*#__PURE__*/React.createElement(React.Fragment, null, fields.map(function (_ref) {
    var key = _ref.key,
      label = _ref.label,
      value = _ref.value;
    var errorMsg = errors[key];
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: label
    }, /*#__PURE__*/React.createElement(Input, {
      error: errorMsg,
      className: "emailcapture-form-input",
      placeholder: label,
      onChange: function onChange(event) {
        return updateFormFields(key, event);
      },
      value: value
    }), errorMsg && /*#__PURE__*/React.createElement("p", {
      className: "emailcapture-form-input-error",
      style: {
        color: descriptionTextColor
      }
    }, errorMsg));
  }), /*#__PURE__*/React.createElement(Button, {
    primary: button.primary,
    loading: isSubmitting,
    disabled: isSubmitting || !recaptchaLoaded,
    onClick: submitForm,
    className: "emailcapture-form-button",
    style: button.primary ? {} : {
      backgroundColor: button.bgColor,
      color: button.textColor
    }
  }, button.label)));
}
FormInputs.defaultProps = defaultProps;